import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { NotificationsProvider } from './context/NotificationsContext';
import { ProductFavoritesProvider } from './context/ProductFavoritesContext';
import { CartProvider } from './context/CartContext';
import { initSentry } from './sentry';

initSentry();

// Montar tu aplicación
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <FavoritesProvider>
        <NotificationsProvider>
          <ProductFavoritesProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </ProductFavoritesProvider>
        </NotificationsProvider>
      </FavoritesProvider>
    </AuthProvider>
  </StrictMode>
);

// ✅ Registrar el Service Worker después de cargar la app
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(() => console.log('✅ Service Worker registrado correctamente'))
      .catch((err) => console.error('❌ Error al registrar el Service Worker:', err));
  });
}
